import { api } from '../utils/axios';

export const getKasm = () => async (dispatch) => {
  
  let data = {}; 

  dispatch({
    type: "GET_KASM_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_kasms', data);
    dispatch({
      type: "GET_KASM_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_KASM_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getKasmId = (kasm_id) => async (dispatch) => {
  
  let data = {};
  data.target_kasm = {"kasm_id": kasm_id};   

  dispatch({
    type: "GET_KASM_ID_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_kasm', data);
    dispatch({
      type: "GET_KASM_ID_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_KASM_ID_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const createImageFromSession = (data) => async (dispatch) => {


  dispatch({
    type: "CREATE_IMAGE_FROM_SESSION_REQUESTED"
  });
  try {
    const response = await api.post('admin/create_image_from_session', data);
    dispatch({
      type: "CREATE_IMAGE_FROM_SESSION_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_IMAGE_FROM_SESSION_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}


